<template>
<v-dialog v-model="show" max-width="600">
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on"></slot>
  </template>
  <v-card>
    <CardTitle title="Select Driver"></CardTitle>
    <v-card-text>
      <v-autocomplete label="Select Driver" :items="drivers"></v-autocomplete>
      <v-autocomplete label="Select Vehicle" :items="vehicles"></v-autocomplete>
    </v-card-text>
    <CardActions>
    </CardActions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "AssignDriver",
  data: () => ({
    show: false,
    drivers: [
        "Devin Hines"
    ],
    vehicles: [
        "White - Honda - Civic"
    ]
  })
}
</script>

<style scoped>

</style>